import { render } from "./storeList.vue?vue&type=template&id=54c70274&scoped=true"
import script from "./storeList.vue?vue&type=script&lang=js"
export * from "./storeList.vue?vue&type=script&lang=js"

import "./storeList.vue?vue&type=style&index=0&id=54c70274&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54c70274"]])

export default __exports__